<template>
  <transition name="fade-slide">
    <div :class="['login-overlay', { active: showLogin }]">
      <div class="login-popup">
        <button class="close-button" aria-label="关闭" @click="emit('close')">
          <AppIcon name="close" size="sm" aria-label="" />
        </button>

        <div class="logo">
          <img :src="BRAND_ASSETS.logo" alt="Logo" />
        </div>

        <div v-if="showErrorPopup" class="error-popup visible">
          {{ apiError }}
        </div>

        <form class="login-form" @submit.prevent="validateLogin">
        <div class="input-group auth-field-phone">
          <input
            id="mobile"
            type="tel"
            placeholder="请输入手机号"
            aria-label="手机号"
            v-model="mobile"
            ref="mobileRef"
            maxlength="11"
            :class="mobileInputClass"
          />
          <p v-if="mobileError" class="error-text">{{ mobileError }}</p>
        </div>

        <div class="input-group auth-field-slider">
          <SliderVerify
            ref="sliderVerifyRef"
            @verify-success="handleVerifySuccess"
          />
        </div>

        <div class="input-group auth-field-verify">
          <div class="verify-code-row">
            <input
              id="verifyCode"
              type="text"
              placeholder="请输入6位验证码"
              aria-label="验证码"
              v-model="verifyCode"
              ref="verifyCodeRef"
              maxlength="6"
              :class="verifyCodeInputClass"
            />
            <button
              type="button"
              class="send-code-btn"
              :disabled="sendCodeDisabled"
              @click="sendVerifyCode"
            >
              {{ sendCodeBtnText }}
            </button>
          </div>
          <p
            v-if="verifyCodeFieldError"
            class="error-text auth-verify-code-api-msg"
          >
            {{ verifyCodeFieldError }}
          </p>
          <p v-else-if="verifyCodeError" class="error-text">
            {{ verifyCodeError }}
          </p>
        </div>

        <button
          type="submit"
          class="login-button"
          :disabled="loginButtonDisabled"
        >
          <template v-if="isLoggingIn">
            <span class="loading-spinner"></span> 登录中...
          </template>
          <template v-else-if="loginSuccess">
            <i class="material-icons success-icon" aria-hidden="true">check_circle</i> 登录成功
          </template>
          <template v-else> 立即登录 </template>
        </button>
        </form>

        <p class="register-prompt">
          还没有账号？
          <a href="#" class="register-link" @click.prevent="emit('show-register')"
            >现在注册</a
          >
        </p>
      </div>
    </div>
  </transition>
</template>

<script setup>
import SliderVerify from '@/shared/components/SliderVerify.vue'
import AppIcon from '@/shared/components/AppIcon.vue'
import { BRAND_ASSETS } from '@/shared/assets/manifest'
import { useLogin } from '@/features/user/composables/useLogin'

const props = defineProps({
  showLogin: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['close', 'show-register', 'login-success'])

const {
  mobile,
  verifyCode,
  mobileError,
  verifyCodeError,
  verifyCodeFieldError,
  apiError,
  isLoggingIn,
  loginSuccess,
  showErrorPopup,
  mobileRef,
  verifyCodeRef,
  sliderVerifyRef,
  mobileInputClass,
  verifyCodeInputClass,
  sendCodeDisabled,
  loginButtonDisabled,
  sendCodeBtnText,
  validateLogin,
  sendVerifyCode,
  handleVerifySuccess,
} = useLogin(props, emit)
</script>

<style scoped src="@/features/user/styles/Login.css"></style>
